import { ComponentPropsWithRef } from "react";

export const GridIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    viewBox="0 0 18 18"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="7" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect y="7" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="7" y="7" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect y="14" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="7" y="14" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="14" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="14" y="7" width="4" height="4" rx="0.5" fill="currentColor" />
    <rect x="14" y="14" width="4" height="4" rx="0.5" fill="currentColor" />
  </svg>
);
